import kumbuLodge1 from '../../images/packages/kumbu-kumbu-lodge/1.jpg';
import kumbuLodge2 from '../../images/packages/kumbu-kumbu-lodge/2.jpg';
import kumbuLodge3 from '../../images/packages/kumbu-kumbu-lodge/3.jpg';
import kumbuLodge4 from '../../images/packages/kumbu-kumbu-lodge/4.jpg';
import kumbuLodge5 from '../../images/packages/kumbu-kumbu-lodge/5.jpg';
import kumbuLodgePdf from '../../docs/packages/kumbu-kumbu-lodge.pdf';

import monteVistaBoutique1 from '../../images/packages/monte-vista-boutique-hotel/1.jpg';
import monteVistaBoutique2 from '../../images/packages/monte-vista-boutique-hotel/2.jpg';
import monteVistaBoutique3 from '../../images/packages/monte-vista-boutique-hotel/3.jpg';
import monteVistaBoutique4 from '../../images/packages/monte-vista-boutique-hotel/4.jpg';
import monteVistaBoutique5 from '../../images/packages/monte-vista-boutique-hotel/5.jpg';
import monteVistaBoutiquePdf from '../../docs/packages/monte-vista-boutique-hotel.pdf';

import villa54Victoria1 from '../../images/packages/villa-54-victoria/1.jpg';
import villa54Victoria2 from '../../images/packages/villa-54-victoria/2.jpg';
import villa54Victoria3 from '../../images/packages/villa-54-victoria/3.jpg';
import villa54Victoria4 from '../../images/packages/villa-54-victoria/4.jpg';
import villa54Victoria5 from '../../images/packages/villa-54-victoria/5.jpg';
import villa54VictoriaPdf from '../../docs/packages/villa-54-victoria.pdf';

import villaOneHilltop1 from '../../images/packages/villa-one-hilltop/1.jpg';
import villaOneHilltop2 from '../../images/packages/villa-one-hilltop/2.jpg';
import villaOneHilltop3 from '../../images/packages/villa-one-hilltop/3.jpg';
import villaOneHilltop4 from '../../images/packages/villa-one-hilltop/4.jpg';
import villaOneHilltop5 from '../../images/packages/villa-one-hilltop/5.jpg';
import villaOneHilltopPdf from '../../docs/packages/villa-one-hilltop.pdf';

import villaMangata1 from '../../images/packages/villa-mangata/1.jpg';
import villaMangata2 from '../../images/packages/villa-mangata/2.jpg';
import villaMangata3 from '../../images/packages/villa-mangata/3.jpg';
import villaMangata4 from '../../images/packages/villa-mangata/4.jpg';
import villaMangata5 from '../../images/packages/villa-mangata/5.jpg';
import villaMangataPdf from '../../docs/packages/villa-mangata.pdf';

import emilyMoonLodge1 from '../../images/packages/emily-moon-lodge/1.jpg';
import emilyMoonLodge2 from '../../images/packages/emily-moon-lodge/2.jpg';
import emilyMoonLodge3 from '../../images/packages/emily-moon-lodge/3.jpg';
import emilyMoonLodge4 from '../../images/packages/emily-moon-lodge/4.jpg';
import emilyMoonLodge5 from '../../images/packages/emily-moon-lodge/5.jpg';
import emilyMoonLodgePdf from '../../docs/packages/emily-moon-lodge.pdf';

import lachataigneFarm1 from '../../images/packages/lachataigne-farm/1.jpg';
import lachataigneFarm2 from '../../images/packages/lachataigne-farm/2.jpg';
import lachataigneFarm3 from '../../images/packages/lachataigne-farm/3.jpg';
import lachataigneFarm4 from '../../images/packages/lachataigne-farm/4.png';
import lachataigneFarm5 from '../../images/packages/lachataigne-farm/5.png';
import lachataigneFarmPdf from '../../docs/packages/lachataigne-farm.pdf';

import ecoKarooLodge1 from '../../images/packages/eco-karoo-lodge/1.png';
import ecoKarooLodge2 from '../../images/packages/eco-karoo-lodge/2.png';
import ecoKarooLodge3 from '../../images/packages/eco-karoo-lodge/3.png';
import ecoKarooLodge4 from '../../images/packages/eco-karoo-lodge/4.png';
import ecoKarooLodge5 from '../../images/packages/eco-karoo-lodge/5.png';
import ecoKarooLodgePdf from '../../docs/packages/eco-karoo-lodge.pdf';

import cradleBoutiqueHotel1 from '../../images/packages/cradle-boutique-hotel/1.png';
import cradleBoutiqueHotel2 from '../../images/packages/cradle-boutique-hotel/2.png';
import cradleBoutiqueHotel3 from '../../images/packages/cradle-boutique-hotel/3.png';
import cradleBoutiqueHotel4 from '../../images/packages/cradle-boutique-hotel/4.png';
import cradleBoutiqueHotel5 from '../../images/packages/cradle-boutique-hotel/5.png';
import cradleBoutiqueHotelPdf from '../../docs/packages/cradle-boutique-hotel.pdf';

import kosiForestLodge1 from '../../images/packages/kosi-forest-lodge/1.jpg';
import kosiForestLodge2 from '../../images/packages/kosi-forest-lodge/2.jpg';
import kosiForestLodge3 from '../../images/packages/kosi-forest-lodge/3.jpg';
import kosiForestLodge4 from '../../images/packages/kosi-forest-lodge/4.jpg';
import kosiForestLodge5 from '../../images/packages/kosi-forest-lodge/5.jpg';
import kosiForestLodgePdf from '../../docs/packages/kosi-forest-lodge.pdf';

import maisonDePlage1 from '../../images/packages/maison-de-plage/1.jpg';
import maisonDePlage2 from '../../images/packages/maison-de-plage/2.jpg';
import maisonDePlage3 from '../../images/packages/maison-de-plage/3.jpg';
import maisonDePlage4 from '../../images/packages/maison-de-plage/4.jpg';
import maisonDePlage5 from '../../images/packages/maison-de-plage/5.jpg';
import maisonDePlagePdf from '../../docs/packages/maison-de-plage.pdf';

import palmsOnTheRocks1 from '../../images/packages/palms-on-the-rocks/1.jpg';
import palmsOnTheRocks2 from '../../images/packages/palms-on-the-rocks/2.jpg';
import palmsOnTheRocks3 from '../../images/packages/palms-on-the-rocks/3.jpg';
import palmsOnTheRocks4 from '../../images/packages/palms-on-the-rocks/4.jpg';
import palmsOnTheRocks5 from '../../images/packages/palms-on-the-rocks/5.jpg';
import palmsOnTheRocksPdf from '../../docs/packages/palms-on-the-rocks.pdf';

import qambathiMountainLodge1 from '../../images/packages/qambathi-mountain-lodge/1.jpg';
import qambathiMountainLodge2 from '../../images/packages/qambathi-mountain-lodge/2.jpg';
import qambathiMountainLodge3 from '../../images/packages/qambathi-mountain-lodge/3.jpg';
import qambathiMountainLodge4 from '../../images/packages/qambathi-mountain-lodge/4.jpg';
import qambathiMountainLodge5 from '../../images/packages/qambathi-mountain-lodge/5.jpg';
import qambathiMountainLodgePdf from '../../docs/packages/qambathi-mountain-lodge.pdf';

import theAfricanRenaissance1 from '../../images/packages/the-african-renaissance/1.jpg';
import theAfricanRenaissance2 from '../../images/packages/the-african-renaissance/2.jpg';
import theAfricanRenaissance3 from '../../images/packages/the-african-renaissance/3.jpg';
import theAfricanRenaissance4 from '../../images/packages/the-african-renaissance/4.jpg';
import theAfricanRenaissance5 from '../../images/packages/the-african-renaissance/5.jpg';
import theAfricanRenaissancePdf from '../../docs/packages/the-african-renaissance.pdf';

import theCoconutShell1 from '../../images/packages/the-coconut-shell/1.jpeg';
import theCoconutShell2 from '../../images/packages/the-coconut-shell/2.jpeg';
import theCoconutShell3 from '../../images/packages/the-coconut-shell/3.jpg';
import theCoconutShell4 from '../../images/packages/the-coconut-shell/4.jpg';
import theCoconutShell5 from '../../images/packages/the-coconut-shell/5.jpg';
import theCoconutShellPdf from '../../docs/packages/the-coconut-shell.pdf';

import bundoxSafariLodge1 from '../../images/packages/bundox-safari-lodge/1.jpg';
import bundoxSafariLodge2 from '../../images/packages/bundox-safari-lodge/2.jpg';
import bundoxSafariLodge3 from '../../images/packages/bundox-safari-lodge/3.jpg';
import bundoxSafariLodge4 from '../../images/packages/bundox-safari-lodge/4.jpg';
import bundoxSafariLodge5 from '../../images/packages/bundox-safari-lodge/5.jpg';
import bundoxsafariLodgePdf from '../../docs/packages/bundox-safari-lodge.pdf';

import sasekaTentedCamp1 from '../../images/packages/saseka-tented-camp/1.jpg';
import sasekaTentedCamp2 from '../../images/packages/saseka-tented-camp/2.jpg';
import sasekaTentedCamp3 from '../../images/packages/saseka-tented-camp/3.jpg';
import sasekaTentedCamp4 from '../../images/packages/saseka-tented-camp/4.jpg';
import sasekaTentedCamp5 from '../../images/packages/saseka-tented-camp/5.jpg';
import sasekaTentedCampPdf from '../../docs/packages/saseka-tented-camp.pdf';

import safariMoonLodge1 from '../../images/packages/safari-moon-lodge/1.jpg';
import safariMoonLodge2 from '../../images/packages/safari-moon-lodge/2.jpg';
import safariMoonLodge3 from '../../images/packages/safari-moon-lodge/3.jpg';
import safariMoonLodge4 from '../../images/packages/safari-moon-lodge/4.jpg';
import safariMoonLodge5 from '../../images/packages/safari-moon-lodge/5.jpg';
import safariMoonLodgePdf from '../../docs/packages/safari-moon-lodge.pdf';

import krugerSunsetLodge1 from '../../images/packages/kruger-sunset-lodge/1.jpg';
import krugerSunsetLodge2 from '../../images/packages/kruger-sunset-lodge/2.jpg';
import krugerSunsetLodge3 from '../../images/packages/kruger-sunset-lodge/3.jpg';
import krugerSunsetLodge4 from '../../images/packages/kruger-sunset-lodge/4.jpg';
import krugerSunsetLodge5 from '../../images/packages/kruger-sunset-lodge/5.jpg';
import krugerSunsetLodgePdf from '../../docs/packages/kruger-sunset-lodge.pdf';

import bakubungVillas1 from '../../images/packages/bakubung-villas/1.jpg';
import bakubungVillas2 from '../../images/packages/bakubung-villas/2.jpg';
import bakubungVillas3 from '../../images/packages/bakubung-villas/3.jpg';
import bakubungVillas4 from '../../images/packages/bakubung-villas/4.jpg';
import bakubungVillas5 from '../../images/packages/bakubung-villas/5.jpg';
import bakubungVillasPdf from '../../docs/packages/bakubung-villas.pdf';

import summerFieldsRoseRetreat1 from '../../images/packages/summerfields-rose-retreat/1.jpg';
import summerFieldsRoseRetreat2 from '../../images/packages/summerfields-rose-retreat/2.jpg';
import summerFieldsRoseRetreat3 from '../../images/packages/summerfields-rose-retreat/3.jpg';
import summerFieldsRoseRetreat4 from '../../images/packages/summerfields-rose-retreat/4.jpg';
import summerFieldsRoseRetreat5 from '../../images/packages/summerfields-rose-retreat/5.jpg';
import summerFieldsRoseRetreatPdf from '../../docs/packages/summerfields-rose-retreat.pdf';

import simbambiliLodge1 from '../../images/packages/simbambili-lodge/1.jpg';
import simbambiliLodge2 from '../../images/packages/simbambili-lodge/2.jpg';
import simbambiliLodge3 from '../../images/packages/simbambili-lodge/3.jpg';
import simbambiliLodge4 from '../../images/packages/simbambili-lodge/4.jpg';
import simbambiliLodge5 from '../../images/packages/simbambili-lodge/5.jpg';
import simbambiliLodgePdf from '../../docs/packages/simbambili-lodge.pdf';

import unembezaBoutiqueLodge1 from '../../images/packages/unembeza-boutique-lodge/1.png';
import unembezaBoutiqueLodge2 from '../../images/packages/unembeza-boutique-lodge/2.png';
import unembezaBoutiqueLodge3 from '../../images/packages/unembeza-boutique-lodge/3.png';
import unembezaBoutiqueLodge4 from '../../images/packages/unembeza-boutique-lodge/4.png';
import unembezaBoutiqueLodge5 from '../../images/packages/unembeza-boutique-lodge/5.png';
import unembezaBoutiqueLodgePdf from '../../docs/packages/unembeza-boutique-lodge.pdf';


import hillsNekSafariLodge1 from '../../images/packages/hillsneck-safari-lodge/HillsNek Boma Evening.jpg';
import hillsNekSafariLodge2 from '../../images/packages/hillsneck-safari-lodge/HillsNek Evening Pool Time.jpg';
import hillsNekSafariLodge3 from '../../images/packages/hillsneck-safari-lodge/HillsNek Safari Camp.jpg';
import hillsNekSafariLodge4 from '../../images/packages/hillsneck-safari-lodge/HillsNek Safari Camp_1.jpg';
import hillsNekSafariLodge5 from '../../images/packages/hillsneck-safari-lodge/HillsNek Safari Camp_2.jpg';
import hillsNekSafariLodgePdf from '../../docs/packages/hillsneck-safari-lodge.pdf';


import oceanaReserve1 from '../../images/packages/oceana-reserve/1.jpg';
import oceanaReserve2 from '../../images/packages/oceana-reserve/2.jpg';
import oceanaReserve3 from '../../images/packages/oceana-reserve/3.jpg';
import oceanaReserve4 from '../../images/packages/oceana-reserve/4.jpg';
import oceanaReserve5 from '../../images/packages/oceana-reserve/5.jpg';
import oceanaReservePdf from '../../docs/packages/oceana-beach-wildlife-reserve.pdf';

import cliftopExclusiveSafari1 from '../../images/packages/clifftop-exclusive-safari/1.jpeg';
import cliftopExclusiveSafari2 from '../../images/packages/clifftop-exclusive-safari/2.jpeg';
import cliftopExclusiveSafari3 from '../../images/packages/clifftop-exclusive-safari/3.jpeg';
import cliftopExclusiveSafari4 from '../../images/packages/clifftop-exclusive-safari/4.jpeg';
import cliftopExclusiveSafari5 from '../../images/packages/clifftop-exclusive-safari/5.jpeg';
import cliftopExclusiveSafariPdf from '../../docs/packages/clifftop-exclusive-safari.pdf';

import maratabaConservationCamps1 from '../../images/packages/marataba-conservation-camps/1.jpg';
import maratabaConservationCamps2 from '../../images/packages/marataba-conservation-camps/2.jpg';
import maratabaConservationCamps3 from '../../images/packages/marataba-conservation-camps/3.jpg';
import maratabaConservationCamps4 from '../../images/packages/marataba-conservation-camps/4.jpg';
import maratabaConservationCamps5 from '../../images/packages/marataba-conservation-camps/5.jpg';
import maratabaConservationCampsPdf from '../../docs/packages/marataba-conservation-camps.pdf';


import ngamaTentedLodge1 from '../../images/packages/ngama-tented-lodge/1.jpg';
import ngamaTentedLodge2 from '../../images/packages/ngama-tented-lodge/2.jpg';
import ngamaTentedLodge3 from '../../images/packages/ngama-tented-lodge/3.jpg';
import ngamaTentedLodge4 from '../../images/packages/ngama-tented-lodge/4.jpg';
import ngamaTentedLodge5 from '../../images/packages/ngama-tented-lodge/5.jpg';
import ngamaTentedLodgePdf from '../../docs/packages/ngama-tented-lodge.pdf';

import lushPrivateGameLodge1 from '../../images/packages/lush-private-game-lodge/1.jpg';
import lushPrivateGameLodge2 from '../../images/packages/lush-private-game-lodge/2.jpg';
import lushPrivateGameLodge3 from '../../images/packages/lush-private-game-lodge/3.jpg';
import lushPrivateGameLodge4 from '../../images/packages/lush-private-game-lodge/4.jpg';
import lushPrivateGameLodge5 from '../../images/packages/lush-private-game-lodge/5.jpg';
import lushPrivateGameLodgePdf from '../../docs/packages/lush-private-game-lodge.pdf';

import witklipfonteinEcoLodge1 from '../../images/packages/witklipfontein-eco-lodge/1.jpg';
import witklipfonteinEcoLodge2 from '../../images/packages/witklipfontein-eco-lodge/2.jpg';
import witklipfonteinEcoLodge3 from '../../images/packages/witklipfontein-eco-lodge/3.jpg';
import witklipfonteinEcoLodge4 from '../../images/packages/witklipfontein-eco-lodge/4.jpg';
import witklipfonteinEcoLodge5 from '../../images/packages/witklipfontein-eco-lodge/5.jpg';
import witklipfonteinEcoLodgePdf from '../../docs/packages/witklipfontein-eco-lodge.pdf';

import malibaLodge1 from '../../images/packages/maliba-lodge/1.jpeg';
import malibaLodge2 from '../../images/packages/maliba-lodge/2.jpeg';
import malibaLodge3 from '../../images/packages/maliba-lodge/3.jpeg';
import malibaLodge4 from '../../images/packages/maliba-lodge/4.jpeg';
import malibaLodge5 from '../../images/packages/maliba-lodge/5.jpeg';
import malibaLodgePdf from '../../docs/packages/maliba-lodge.pdf';

import gocheganasLodge1 from '../../images/packages/gocheganas-lodge/1.jpeg';
import gocheganasLodge2 from '../../images/packages/gocheganas-lodge/2.jpeg';
import gocheganasLodge3 from '../../images/packages/gocheganas-lodge/3.jpeg';
import gocheganasLodge4 from '../../images/packages/gocheganas-lodge/4.jpeg';
import gocheganasLodge5 from '../../images/packages/gocheganas-lodge/5.jpeg';
import gocheganasLodgePdf from '../../docs/packages/gocheganas-lodge.pdf';

import shipwreckLodge1 from '../../images/packages/shipwreck-lodge/1.png';
import shipwreckLodge2 from '../../images/packages/shipwreck-lodge/2.png';
import shipwreckLodge3 from '../../images/packages/shipwreck-lodge/3.jpeg';
import shipwreckLodge4 from '../../images/packages/shipwreck-lodge/4.jpeg';
import shipwreckLodge5 from '../../images/packages/shipwreck-lodge/5.jpeg';
import shipwreckLodgePdf from '../../docs/packages/shipwreck-lodge.pdf';

import zannierHotelsOmaanda1 from '../../images/packages/zannier-hotels-omaanda/1.jpg';
import zannierHotelsOmaanda2 from '../../images/packages/zannier-hotels-omaanda/2.jpg';
import zannierHotelsOmaanda3 from '../../images/packages/zannier-hotels-omaanda/3.jpg';
import zannierHotelsOmaanda4 from '../../images/packages/zannier-hotels-omaanda/4.jpg';
import zannierHotelsOmaanda5 from '../../images/packages/zannier-hotels-omaanda/5.jpg';
import zannierHotelsOmaandaPdf from '../../docs/packages/zannier-hotels-omaanda.pdf';

import zannierHotelsSonop1 from '../../images/packages/zannier-hotels-sonop/1.jpg';
import zannierHotelsSonop2 from '../../images/packages/zannier-hotels-sonop/2.jpg';
import zannierHotelsSonop3 from '../../images/packages/zannier-hotels-sonop/3.jpg';
import zannierHotelsSonop4 from '../../images/packages/zannier-hotels-sonop/4.jpg';
import zannierHotelsSonop5 from '../../images/packages/zannier-hotels-sonop/5.jpg';
import zannierHotelsSonopPdf from '../../docs/packages/zannier-hotels-sonop.pdf';

const packages = [

    {
        name: 'Zannier Hotels Sonop',
        description: "Stretching from horizon to horizon, captivating beauty and boundless freedom surround you, with adventures from sunrise to sunset. The one- and two-bedroom tented suites embrace views of the untamed desert, each featuring a partially-walled bathroom, vintage bathtub and private terrace. With guided excursions including horse-riding, electric fat bike or walking trails, hot air balloon safari and private sunrise or sunset safaris to give you an experience of Africa like never before!",
        price: {
            value: 9780.00,
            quanity: 'per hut, per night'
        },
        location: 'Sonop Farm, Karas Region, Nambia',
        province: 'africa',
        audience: 'Suitable for weekend hideaways, friend getaways, couple getaways and family trips',
        pdf: zannierHotelsSonopPdf,
        images: [
            zannierHotelsSonop1,
            zannierHotelsSonop2,
            zannierHotelsSonop3,
            zannierHotelsSonop4,
            zannierHotelsSonop5,
        ]
    },
    {
        name: 'Zannier Hotels Omaanda',
        description: "Omaanda is a luxurious lodge set within the Zannier Reserve. Overlooking the boundless savannah, the camp offers ten spacious round thatched huts, whose warmth design, evocative of the earth, is inspired by the traditional architecture of Owambo. The authentic Ambo Delights restaurant serves refined cuisine, from homemade breakfast to delicious dishes to share, including generous pieces of ‘game meat’ on a spit. Melting into the incredible background, the bar on the edge of the heated outdoor infinity pool offers a refreshing retreat after unforgettable made-to-measure excursions and safaris.",
        price: {
            value: 8760.00,
            quanity: 'per hut, per night'
        },
        location: 'Kapps Farm, Windhoek, Namibia',
        province: 'africa',
        audience: 'Suitable for family vacations, group-cations & family getaways',
        pdf: zannierHotelsOmaandaPdf,
        images: [
            zannierHotelsOmaanda1,
            zannierHotelsOmaanda2,
            zannierHotelsOmaanda3,
            zannierHotelsOmaanda4,
            zannierHotelsOmaanda5,
        ]
    },
    {
        name: 'ShipWreck Lodge',
        description: "Located in the famous Skeleton Coast concession between the Hoarusib and Hoanib rivers in the Skeleton Coast National Park, Shipwreck Lodge is only 45 km from Möwe Bay. The shipwreck-shaped cabins are nestled between the dunes with a view of the Atlantic Ocean where the cold Benguela current provides guests with a refreshing breeze. Our exclusive clients can look forward to appreciating the harshness of the desert and the beauty of these solitary landscapes filled with geological history. Contact us to start your journey into the desert!",
        price: {
            value: 19500.00,
            quanity: 'per person per night'
        },
        location: 'Möwe Bay, Namibia',
        province: 'africa',
        audience: 'Suitable for couple getaways, solo trips and group vacations',
        pdf: shipwreckLodgePdf,
        images: [
            shipwreckLodge1,
            shipwreckLodge2,
            shipwreckLodge3,
            shipwreckLodge4,
            shipwreckLodge5,
        ]
    },
    {
        name: 'GocheGanas Lodge',
        description: "GocheGanas offers its guests the unique experience of enjoying a combination of hospitality, wellness, wildlife and nature, all working together to compliment a sense of well-being.The tranquil surroundings, stunning landscapes and glimpses of herds of game beckons our guests to enjoy the variety of activities we have on offer, ranging from our outdoor activities such as walks and guided game drives to relaxing in the comfort of the Wellness Village.Situated a mere 29 kilometres South East from Windhoek on a hilltop overlooking a spectacular landscape, GocheGanas is a Luxury Lodge offering a unique combination of Wildlife, Nature and Wellness experiences.",
        price: {
            value: 3500.00,
            quanity: 'per person'
        },
        location: '25 km from Windhoek, Nambia',
        province: 'africa',
        audience: 'Suitable for couple & friend get-aways, and family trips',
        pdf: gocheganasLodgePdf,
        images: [
            gocheganasLodge1,
            gocheganasLodge2,
            gocheganasLodge3,
            gocheganasLodge4,
            gocheganasLodge5,
        ]
    },
    {
        name: 'Maliba Lodge',
        description: "Maliba Lodge is the first and only 5-star luxury Lesotho accommodation in Southern Africa. Maliba Lodge offers accommodation to suit all the budgets from luxury mountain lodge to self catering lodges with the mountain view. The award winning lodge has a spa, Bana Kids Club, 5-star gourmet restaurant, Bistro and amazing staff that cater to your every need. Prepare your Lesotho vacation with Maliba Lodge and enjoy another unique side to Africa.",
        price: {
            value: 2500.00,
            quanity: 'per person'
        },
        location: 'Tshehlanyane National Park, Lesotho',
        province: 'africa',
        audience: 'Suitable for couple & friend get-aways, and family trips',
        pdf: malibaLodgePdf,
        images: [
            malibaLodge1,
            malibaLodge2,
            malibaLodge3,
            malibaLodge4,
            malibaLodge5,
        ]
    },
    {
        name: 'Witklipfontein Eco Lodge',
        description: "Witklipfontein is one of the original farms of The Vredefort Dome, a Unesco World Heritage site. The experience of the farm includes an access to their permaculture vegetable garden, fresh farm eggs from their chickens, interactions with the goats and horses and of course hiking on the territory of our giraffes, zebras, various antelopes, warthogs, and other human friendly animals. This contemporary villa provides scenic, eco-friendly experiences for the traveller who loves nature and cares for the eco-system, as we should all!",
        price: {
            value: 6800.00,
            quanity: 'per group'
        },
        location: 'Vredefort Dome, North West',
        province: 'north-west',
        audience: 'Suitable for couple & friend get-aways, and family trips',
        pdf: witklipfonteinEcoLodgePdf,
        images: [
            witklipfonteinEcoLodge1,
            witklipfonteinEcoLodge2,
            witklipfonteinEcoLodge3,
            witklipfonteinEcoLodge4,
            witklipfonteinEcoLodge5,
        ]
    },
    {
        name: 'Lush Private Lodge',
        description: "Lush is a Lupini family-owned and managed boutique private game lodge, set within the Black Rhino Reserve of the greater Pilanesberg National Park and run on Italian hospitality, offering luxury accommodation, dining, and safari experiences. As a guest of Lush, you are assured a private – and unique – safari experience, with the rare opportunity to see the black rhino. The lodge has traversing access to the whole of Pilanesberg, including the Black Rhino Game Reserve and the park’s limited-access Wilderness Area – established for the protection and breeding of this critically endangered animal, threatened by poaching. Contact us to make a booking.",
        price: {
            value: 5490.00,
            quanity: 'per person'
        },
        location: 'Pilanesberg, North West',
        province: 'north-west',
        audience: 'Suitable for couple getaways, solo trips & friend-cations',
        pdf: lushPrivateGameLodgePdf,
        images: [
            lushPrivateGameLodge1,
            lushPrivateGameLodge2,
            lushPrivateGameLodge3,
            lushPrivateGameLodge4,
            lushPrivateGameLodge5,
        ]
    },
    {
        name: 'Ngama Tented Lodge',
        description: "Enjoy the romance of canvas, with sounds of the wild and flickering lanterns lighting the camp grounds. Feel the bush-veld breeze into your tent or enjoy a view of the great outdoors from the luxurious bathtub. Ngama is an intimate safari lodge with 6 spacious tented chalets, designed after classic safari tents but with all the modern amenities and an experience you deserve to enjoy! Explore our catalogue and find a package suitable for you!",
        price: {
            value: 5300.00,
            quanity: 'per couple'
        },
        location: 'Hoedspruit, Limpopo',
        province: 'limpopo',
        audience: 'Suitable for Couple Getaways, friend & family retreats',
        pdf: ngamaTentedLodgePdf,
        images: [
            ngamaTentedLodge1,
            ngamaTentedLodge2,
            ngamaTentedLodge3,
            ngamaTentedLodge4,
            ngamaTentedLodge5,
        ]
    },
    {
        name: 'Marataba Conservation Camps',
        description: "Marataba Conservation Camps is a conservation-led safari experience that gives guests the chance to get involved in thoughtful and interactive activities including wildlife management and ecological conservation, participate in stimulating discussions with conservationists and experts, and to travel with a purpose. Includes a Founder's Camp which attracts a variety of wildlife. The suites are tucked under the trees and have large decks from which to enjoy the water, & also has an Explorer's Camp with views of the Waterberg mountain range, bushveld savannah and a prolific waterhole both from the tents and from the main area - making it perfect for families to explore, relax whilst creating special memories to keep for life!",
        price: {
            value: 4350.00,
            quanity: 'per person'
        },
        location: 'Marakele National Park, Limpopo',
        province: 'limpopo',
        audience: 'Suitable for group baecations, squad-trips and family retreats',
        pdf: maratabaConservationCampsPdf,
        images: [
            maratabaConservationCamps1,
            maratabaConservationCamps2,
            maratabaConservationCamps3,
            maratabaConservationCamps4,
            maratabaConservationCamps5,
        ]
    },

    {
        name: 'Clifftop Exclusive Safari Lodge',
        description: 'Perched regally amidst the bush willows on the tip of a magnificent gorge overlooking the Sterkstroom River, Clifftop Exclusive Safari Hideaway is your idyllic sanctuary in the African Bush. A romantic, secluded hideaway from the world’s worries that caters to an intimate encounter with the magnificent UNESCO Waterberg Biosphere inside Welgevonden Private Game Reserve. Relax on your private deck enjoying the cool breeze or sip a full-bodied red wine in front of one of the lodge’s cosy fires. Whether you’re on honeymoon or simply seeking a romantic sojourn, Clifftop Exclusive Safari Hideaway will soothe your soul and give you an experience you will not forget.',
        price: {
            value: 6400.00,
            quanity: 'per person'
        },
        location: 'Welgevonden private game reserve, Limpopo',
        province: 'limpopo',
        audience: 'Suitable for couple trips, solo trips and friend-cations',
        pdf: cliftopExclusiveSafariPdf,
        images: [
            cliftopExclusiveSafari1,
            cliftopExclusiveSafari2,
            cliftopExclusiveSafari3,
            cliftopExclusiveSafari4,
            cliftopExclusiveSafari5,
        ]
    },
    {
        name: 'Oceana Beach and Wildlife Reserve',
        description: 'Oceana is the perfect compliment to the traditional safari experience. With a custom itinerary designed each day so you can choose to do a mid-morning nature drive, relaxing spa treatments, a beach lunch or just read a book on your deck overlooking the Indian Ocean. This ultimate African luxury experience is made complete by a spa, gym, games room, and South African inspired fine dining. With exceptional views and scenery – this is where you want to go for your next holiday.',
        price: {
            value: 4750.00,
            quanity: 'per person'
        },
        location: 'Port Alfred, Eastern Cape',
        province: 'eastern-cape',
        audience: 'Suitable for Couple getaways, friend trips & family vacations and special occasions (weddings, etc)',
        pdf: oceanaReservePdf,
        images: [
            oceanaReserve1,
            oceanaReserve2,
            oceanaReserve3,
            oceanaReserve4,
            oceanaReserve5,
        ]
    },

    {
        name: 'Hillsneck Safari Lodge',
        description: 'HillsNek Safari Camp is positioned in a secluded corner of the Amakhala Game Reserve in the malaria-free Eastern Cape, South Africa. This intimate family-run lodge is set on the banks of the Bushman’s River with a breath-taking vista of rolling African plains. HillsNek Safari Camp offers an unprecedented safari experience where privacy and personalized attention is the hallmark of every stay. If you have never visited the Eastern Cape - we highly recommend you start right here!',
        price: {
            value: 2800.00,
            quanity: 'per person'
        },
        location: 'Amakhala Game Reserve, Eastern Cape',
        province: 'eastern-cape',
        audience: 'Suitable for couple getaways, family trips & squadcations',
        pdf: hillsNekSafariLodgePdf,
        images: [
            hillsNekSafariLodge1,
            hillsNekSafariLodge2,
            hillsNekSafariLodge3,
            hillsNekSafariLodge4,
            hillsNekSafariLodge5,
        ]
    },
    {
        name: 'Kumbu-Kumbu Lodge',
        description: 'Set in Montague, these charming mountain villas provide optimal privacy and tranquillity. Should you crave a road trip with your partner or a friend-cation in the summertime, Kumbu-Kumbu Lodge is the perfect fit. Explore the catalogue and book a package.',
        price: {
            value: 3500.00,
            quanity: 'per couple'
        },
        location: 'Montagu, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for couple getaways, relaxation & retreat vacations',
        pdf: kumbuLodgePdf,
        images: [
            kumbuLodge1,
            kumbuLodge2,
            kumbuLodge3,
            kumbuLodge4,
            kumbuLodge5,
        ]
    }, {
        name: 'Villa One Hilltop',
        description: 'This masterful and expansive villa gives off a particular type of beach paradise feel. You could possibly stay here on a road trip or tour exploring the Cape Peninsula. With beautiful days at the beach and sunset braai’s, this villa is perfect for families or groups of friends. Explore the catalogue and book one of our packages.',
        price: {
            value: 1375.00,
            quanity: 'per person'
        },
        location: 'Scarborough, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for couple getaways, relaxation & retreat vacations',
        pdf: villaOneHilltopPdf,
        images: [
            villaOneHilltop1,
            villaOneHilltop2,
            villaOneHilltop3,
            villaOneHilltop4,
            villaOneHilltop5,
        ]
    },

    {
        name: 'Villa 54 Victoria',
        description: 'Set within a very prominent area of Bakoven, this quirky villa provides expansive views that are sure to provide vibes of ultimate relaxation. With plenty of activities and experiences to do, this villa is a keeper for big families and friends. Explore the catalogue and book your favourite package.',
        price: {
            value: 6215.00,
            quanity: 'per couple'
        },
        location: 'Bakoven, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for couple getaways, relaxation & retreat vacations',
        pdf: villa54VictoriaPdf,
        images: [
            villa54Victoria1,
            villa54Victoria2,
            villa54Victoria3,
            villa54Victoria4,
            villa54Victoria5
        ]
    },

    {
        name: 'Monte Vista Boutique Hotel',
        description: 'Ahhhh Montagu, what a charming little town with picturesque mountain views that will leave you in awe. Set admits the mountain and vine, this boutique hotel is perfect for couples, friends, and even solo vacations. Explore the catalogue and book your dates now.',
        price: {
            value: 3600.00,
            quanity: 'per couple'
        },
        location: 'Bakoven, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for couple getaways, relaxation & retreat vacations',
        pdf: monteVistaBoutiquePdf,
        images: [
            monteVistaBoutique1,
            monteVistaBoutique2,
            monteVistaBoutique3,
            monteVistaBoutique4,
            monteVistaBoutique5,
        ]
    },

    {
        name: 'Bakubung Villas',
        description: 'Sun City remains a favorite with these newly renovated and tranquil villas. Nestled within the Plinaesberg mountains enjoy your very own piece of luxury with sounds of the African Bush and serene surroundings that speak to your soul. Explore the catalogue and book your dates now.',
        price: {
            value: 3400.00,
            quanity: 'per person'
        },
        location: 'Pilanesberg National Park, North West',
        province: 'north-west',
        audience: 'Suitable for couple getaways, family trips, friend-cations and special occasions',
        pdf: bakubungVillasPdf,
        images: [
            bakubungVillas1,
            bakubungVillas2,
            bakubungVillas3,
            bakubungVillas4,
            bakubungVillas5
        ]
    },

    {
        name: 'Cradle Boutique Hotel',
        description: 'With tales from the origins of life. This boutique hotel emanates the rhythm of life that takes you on a journey that explores your roots. Ideal for weddings, spontaneous vacations and family trips. Explore the catalogue and book your getaway now.',
        price: {
            value: 5400.00,
            quanity: 'per couple'
        },
        location: 'Pilanesberg National Park, North West',
        province: 'north-west',
        audience: 'Suitable for couple getaways, family trips, friend-cations and special occasions',
        pdf: cradleBoutiqueHotelPdf,
        images: [
            cradleBoutiqueHotel1,
            cradleBoutiqueHotel2,
            cradleBoutiqueHotel3,
            cradleBoutiqueHotel4,
            cradleBoutiqueHotel5,
        ]
    },

    {
        name: 'Bundox Safari Lodge',
        description: 'Located in a private nature reserve this authentic safari escape is exactly what you and your close one need. Whether you’re on a son/daughter vacation, couple getaway or double vacation, this ambient lodge masters the balance between rest and adventure. Explore the catalogue and book your favourite package.',
        price: {
            value: 4600.00,
            quanity: 'per couple'
        },
        location: 'Hoedspruit, Limpopo',
        province: 'limpopo',
        audience: 'Suitable for couple getaways, family trips, friend-cations and special occasions',
        pdf: bundoxsafariLodgePdf,
        images: [
            bundoxSafariLodge1,
            bundoxSafariLodge2,
            bundoxSafariLodge3,
            bundoxSafariLodge4,
            bundoxSafariLodge5,
        ]
    },

    {
        name: 'Eco Karoo Lodge',
        description: 'Built with the intention of embracing local craftsmanship this secluded lodge is perfect for you if you’re looking for a unique escape full of wonder. Eco Karoo Lodge is situated at the foot of majestic mountains to the west and endless plains to the east; perfect for weekend hideaways, friend getaways, couple getaways, eloping and even solo trips. Explore the catalogue and book your favourite package.',
        price: {
            value: 2600.00,
            quanity: 'per couple'
        },
        location: 'Luckhoff, Free State',
        province: 'free-state',
        audience: 'Suitable for weekend hideaways, friend getaways, couple getaways and solo trips',
        pdf: ecoKarooLodgePdf,
        images: [
            ecoKarooLodge1,
            ecoKarooLodge2,
            ecoKarooLodge3,
            ecoKarooLodge4,
            ecoKarooLodge5,
        ]
    },
    {
        name: 'Emily Moon Lodge',
        description: 'This enchanting and exclusive boutique hotel is a true escape for lovers, friends and families. Situated on the Bitou River, scenic views and serenity is the ambiance that you feel throughout the hotel. The quirky and eclectic setting adds an authentic charm that couples, groups of friends and guests would appreciate.  Explore the catalogue and book your favourite package.',
        price: {
            value: 6600.00,
            quanity: 'per couple'
        },
        location: 'Plettenberg Bay, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for couple getaways, weddings, special occasions, soulful retreats and solo trips',
        pdf: emilyMoonLodgePdf,
        images: [
            emilyMoonLodge1,
            emilyMoonLodge2,
            emilyMoonLodge3,
            emilyMoonLodge4,
            emilyMoonLodge5,
        ]
    },

    {
        name: 'Kosi Forest Lodge',
        description: 'Tucked away in one of the unique corners of South Africa, the Lodge has a rustic - yet comfortable - aesthetic that provides an authentic ‘back to nature’ experience. You’ll wake up in the morning surrounded by the sounds of the forest’s prolific bird life, open air and lush vegetation. Two words, truly unforgettable. If you’re considering  a couple getaway, adventure trip or family holiday this is a definite option. Explore the catalogue and get in touch to book your dates.',
        price: {
            value: 6500.00,
            quanity: 'per couple'
        },
        location: 'iSimangaliso Wetlands Park, Kwa-zulu Natal',
        province: 'kwa-zulu-natal',
        audience: 'Suitable for couple getaways, adventure and family trips.',
        pdf: kosiForestLodgePdf,
        images: [
            kosiForestLodge1,
            kosiForestLodge2,
            kosiForestLodge3,
            kosiForestLodge4,
            kosiForestLodge5,
        ]
    },

    {
        name: 'Kruger Sunset Lodge',
        description: 'This luxurious villa incorporates a sense of exclusive luxury that is rare to capture in most places. Having the entire 5 bedroom villa for exclusive use, this home is perfect for groups of friends or families looking to spend quality time in the bush. With vast plains that boast daily views of the game, the harmonious aura of the home is truly unforgettable. Book your dates and explore the iconic possibilities of spaces that incorporate indoor and outdoor living.',
        price: {
            value: 2400.00,
            quanity: 'per person'
        },
        location: 'Mjejane Game Reserve, Mpumalanga',
        province: 'mpumalanga',
        audience: 'Suitable for couple getaways, friends, family vacations and special occasions',
        pdf: krugerSunsetLodgePdf,
        images: [
            krugerSunsetLodge1,
            krugerSunsetLodge2,
            krugerSunsetLodge3,
            krugerSunsetLodge4,
            krugerSunsetLodge5,
        ]
    },

    {
        name: 'La Chataigne Farm',
        description: 'Situated within the heart of the winelands, this charming farm boasts scenic mountain views and an authentic feel that truly complements Franschhoek. Located near a river stream, the farm boasts a calming aesthetic that is sure to leave friends, families and couples feeling refreshed. Book your dates and explore the iconic possibilities of vineyard and farm living.',
        price: {
            value: 5400.00,
            quanity: 'per couple'
        },
        location: 'Franschhoek, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for couple getaways, friends, family vacations and wine experiences.',
        pdf: lachataigneFarmPdf,
        images: [
            lachataigneFarm1,
            lachataigneFarm2,
            lachataigneFarm3,
            lachataigneFarm4,
            lachataigneFarm5,
        ]
    },

    {
        name: 'Maison De Plage’',
        description: 'Sea breeze and ocean views inspire the harmony of this perfectly appointed villa. Situated in Umdloti Beach, this villa perfectly incorporates indoor and outdoor living. With a pool, external garden and veranda this home is perfect for special occasions, friend-cations and exciting family trips. Book your dates and experience this paradise.',
        price: {
            value: 3500.00,
            quanity: 'per couple'
        },
        location: 'Umdloti, Kwa-zulu Natal',
        province: 'kwa-zulu-natal',
        audience: 'Suitable for couple getaways, family vacations and special occasions',
        pdf: maisonDePlagePdf,
        images: [
            maisonDePlage1,
            maisonDePlage2,
            maisonDePlage3,
            maisonDePlage4,
            maisonDePlage5,
        ]
    },

    {
        name: 'Qambathi Mountain Lodge',
        description: 'This magical boutique hotel makes for a perfect escape in the Kzn Midlands. With a calming interior, Zebra’s in the backyard, a wine cellar and plenty to do- you are sure to experience a fairytale moment. Book your dates for your couple’s retreat, wedding, special occasion or spiritual retreat.',
        price: {
            value: 5400.00,
            quanity: 'per couple'
        },
        location: 'Midlands, Kwa-zulu Natal',
        province: 'kwa-zulu-natal',
        audience: 'Suitable for couple getaways, family vacations, special occasions, spiritual retreats and road trips.',
        pdf: qambathiMountainLodgePdf,
        images: [
            qambathiMountainLodge1,
            qambathiMountainLodge2,
            qambathiMountainLodge3,
            qambathiMountainLodge4,
            qambathiMountainLodge5,
        ]
    },

    {
        name: 'Palms on Rocks',
        description: 'Perfectly positioned on a premium part of beach-side property, this contemporary Villa promises to entice and excite you. Whether you’re waking up or enjoying sundowners to this view, you are sure to experience a good slice of paradise. The undercover terrance and sophisticated open plan living, leaves you feeling expansive and fulfilled. Perfect for large families or good friends, book your dates now and unleash your paradise.',
        price: {
            value: 2000.00,
            quanity: 'per person'
        },
        location: 'Ballito, Kwa-zulu Natal',
        province: 'kwa-zulu-natal',
        audience: 'Suitable for couple getaways, family vacations, friend-cation and road trips.',
        pdf: palmsOnTheRocksPdf,
        images: [

            palmsOnTheRocks1,
            palmsOnTheRocks2,
            palmsOnTheRocks3,
            palmsOnTheRocks4,
            palmsOnTheRocks5,
        ]
    },

    {
        name: 'Safari Moon Lodge',
        description: 'Positioned in the abundant area of Hoedspruit, this luxurious and tranquil lodge promises to spark your curiosity and recreate some much needed freedom and love. Lavishy blessed with eclectic furniture and pieces, this lodge is perfect for large families, art/decor enthusiasts or good friends. Book your dates now and unleash your paradise.',
        price: {
            value: 5000.00,
            quanity: 'per couple'
        },
        location: 'Hoedspruit, Limpopo',
        province: 'limpopo',
        audience: 'Suitable for couple & friend getaways, weekend hideaway, road trip and special occasion.',
        pdf: safariMoonLodgePdf,
        images: [
            safariMoonLodge1,
            safariMoonLodge2,
            safariMoonLodge3,
            safariMoonLodge4,
            safariMoonLodge5,
        ]
    },

    {
        name: 'Summerfields Rose Retreat and Spa',
        description: 'With spring underway and plenty of opportunities coming our way, the Sumerfied retreat and Spa is a perfect place to unwind, reconnect and rejuvenate. The retreat highly values comfort, relaxation and romance, making it perfect for large families, art/decor enthusiasts or good friends. Book your dates now and unleash your paradise.',
        price: {
            value: 5000.00,
            quanity: 'per couple'
        },
        location: 'Hazyview, Mpumalanga',
        province: 'mpumalanga',
        audience: 'Suitable for couples, honeymoons and bachelorettes.',
        pdf: summerFieldsRoseRetreatPdf,
        images: [summerFieldsRoseRetreat1, summerFieldsRoseRetreat2, summerFieldsRoseRetreat3, summerFieldsRoseRetreat4, summerFieldsRoseRetreat5]
    },

    {
        name: 'The African Renaissance',
        description: 'A wine room, indoor garden, an entertainment space and a pool; this villa oozes sophisticated living and is sure to satisfy anyone looking to celebrate special occasions, family holidays and good friends. With a lawn and expansive views, this perfectly positioned villa has plenty to offer. Book your dates now and unleash the experience you deserve.',
        price: {
            value: 2000.00,
            quanity: 'per person'
        },
        location: 'Ballito, Kwa-zulu Natal',
        province: 'kwa-zulu-natal',
        audience: 'Suitable for family vacations, special occasions and group-cations.',
        pdf: theAfricanRenaissancePdf,
        images: [
            theAfricanRenaissance1,
            theAfricanRenaissance2,
            theAfricanRenaissance3,
            theAfricanRenaissance4,
            theAfricanRenaissance5,
        ]
    },

    {
        name: 'The Coconut Shell',
        description: 'This villa is the best representation of Asia meets Zulu Kingdom. With strong Balinese inspiration, this villa gives off the feeling of a private jungle paradise that is sure to leave you wanting to extend your stay. Whether you’re watching dolphins or whales flopping in the distance or enjoying a day by the pool; this perfectly positioned villa has plenty to offer. Book your dates now and unleash the experience you deserve.',
        price: {
            value: 2000.00,
            quanity: 'per person'
        },
        location: 'Salt Rock, Kwa-Zulu Natal',
        province: 'kwa-zulu-natal',
        audience: 'Suitable for family vacations, special occasions and group-cations.',
        pdf: theCoconutShellPdf,
        images: [
            theCoconutShell1,
            theCoconutShell2,
            theCoconutShell3,
            theCoconutShell4,
            theCoconutShell5,
        ]
    },

    {
        name: 'Unembeza Boutique Lodge',
        description: 'Blyde River Canyon, Kruger National Park and lovely spaces? It’s the biodiversity for us. Hoedspruit Limpopo is one of our most recommended locations in South Africa. This region has plenty to offer and Unembeza is perfectly positioned to offer all that adventure seekers, couples and families need. Book your dates now and explore the possibilities.',
        price: {
            value: 3000.00,
            quanity: 'per person'
        },
        location: 'Hoedspruit, Limpopo',
        province: 'limpopo',
        audience: 'Suitable for family vacations, friend-cations, special occasions and bachelorettes.',
        pdf: unembezaBoutiqueLodgePdf,
        images: [unembezaBoutiqueLodge1, unembezaBoutiqueLodge2, unembezaBoutiqueLodge3, unembezaBoutiqueLodge4, unembezaBoutiqueLodge5]
    },

    {
        name: 'Villa Mangata',
        description: 'Waking up to gentle sounds of the waves, the apartment boasts an expansive landscape view for the books! Staying here with friends and family, will certainly leave you encouraged and motivated. With plenty of things to do in the area, it will be hard to watch your stay come to an end. Book your dates now and explore the possibilities.',
        price: {
            value: 2750.00,
            quanity: 'per person'
        },
        location: 'Bakoven, Western Cape',
        province: 'western-cape',
        audience: 'Suitable for family vacations, friend-cations and special occasions.',
        pdf: villaMangataPdf,
        images: [
            villaMangata1,
            villaMangata2,
            villaMangata3,
            villaMangata4,
            villaMangata5,
        ]
    },

    {
        name: 'Tented Camp Saseka',
        description: 'Saseka, meaning beautiful in Tsonga, resembles an art form of Safari Experiences. Nestled in the private Thornybush Game Reserve, there’s a primal reason why she forms part of our Luxe family. Careful attention has been placed on the overall aesthetic and feel of the camp. Inspired by the tents in yesteryear the Saseka’s main area is a combination of wood and stone cladding. Which blends naturally into the surrounding environment and offers both an upper and lower-deck with the colour palette drawn from the natural surroundings; hues of ivory, dark green, apple, sage and subtle flushes of pink echoing the characteristic tones of the flowers found in the bush.  The lodge’s main area is a celebration of nature with the use of light being key.  If you\'re looking for a romantic escape or are inspired by beautiful spaces, book your dates and let us curate the perfect experience.',
        price: {
            value: 20000.00,
            quanity: 'per person'
        },
        location: 'Thornybush Game Reserve, Hoedspruit',
        province: 'limpopo',
        audience: 'Suitable for couple getaways, honeymoons and interior decor enthusiasts.',
        pdf: sasekaTentedCampPdf,
        images: [
            sasekaTentedCamp1,
            sasekaTentedCamp2,
            sasekaTentedCamp3,
            sasekaTentedCamp4,
            sasekaTentedCamp5,
        ]
    },

    {
        name: 'Simbambili',
        description: 'Intimate and cozy with a sentimental touch of tranquility. Simbambili is well complemented by its surroundings; with spaces that enhance that every moment. This is the perfect place to relax, explore and enjoy with your family or partner. Enjoy a spa date, special dinner, game drive, private sundowners experience or a pool party on your private deck. Book your dates now and unleash your paradise.',
        price: {
            value: 20000.00,
            quanity: 'per person'
        },
        location: 'Sabi Sabi Sands, Mpumalanga',
        province: 'mpumalanga',
        audience: 'Suitable for couple getaways, honeymoons and interior decor enthusiasts.',
        pdf: simbambiliLodgePdf,
        images: [
            simbambiliLodge1,
            simbambiliLodge2,
            simbambiliLodge3,
            simbambiliLodge4,
            simbambiliLodge5
        ]
    },


];

export {
    packages
};